<div class="hero-section">
  <app-background-gradient
    position="custom"
    top="-50px"
    left="50%"
    translateX="-50%"
    [opacity]="0.5"
    width="1280px"
    height="516px"
  ></app-background-gradient>
</div>

@if (creative) {
  <div class="hero-title hero-title-creative">
    <div class="hero-text">
      <h1 class="x-large">
        {{ 'landing.hero.title_line1' | translate }}
        <br/>
        {{ 'landing.hero.title_line2' | translate }}
      </h1>
      <p>
        {{ 'landing.hero.subtitle' | translate }}
      </p>
      <div class="flex gap-4 hero-cta">
        <app-button customIconSrc="/assets/icons/magic-wand.svg" size="large" [shadow]="false" routerLink="project" fragment="top" [label]="'landing.hero.cta_create' | translate"></app-button>
        <app-button size="large" [shadow]="false" color="pink" routerLink="project" fragment="top" [label]="'landing.hero.cta_inspire' | translate"></app-button>
      </div>
    </div>
  </div>
} @else {
  <div class="hero-title">
    <div class="hero-text">
      <h1 class="x-large">
        {{ 'landing.hero.title_line1' | translate }}
        <br/>
        {{ 'landing.hero.title_line2' | translate }}
      </h1>
      <p>
        {{ 'landing.hero.subtitle' | translate }}
      </p>
      <div class="flex gap-4 hero-cta">
        <app-button customIconSrc="/assets/icons/magic-wand.svg" size="x-large" [shadow]="false" routerLink="project" fragment="top" [label]="'landing.hero.cta_create' | translate"></app-button>
        <app-button class="hero-secondary-cta" size="large" [shadow]="false" color="pink" routerLink="project" fragment="top" [label]="'landing.hero.cta_inspire' | translate"></app-button>
      </div>
    </div>
    <div class="header-slider">
      <p-carousel [value]="products" [numVisible]="1" [numScroll]="1" [circular]="false" [showNavigators]="false" autoplayInterval="5000">
        <ng-template let-product #item>
          <div class="relative">
            <img class="w-full" [src]="product.images[0]?.urls?.large" />
            <div class="flex justify-content-center">
              <div class="pill-white" [routerLink]="projectLink" [queryParams]="{ productId: product.id }" fragment="top">
                <span>{{product.name}}</span>
              </div>
            </div>
          </div>
        </ng-template>
      </p-carousel>
    </div>
  </div>
}
